<p-toast>
  <ng-template let-message #message>
    <i [class]="`self-center ${getIconClass(message.severity)}`"></i>
    <div class="flex-1">{{ message.detail }}</div>
  </ng-template>
</p-toast>
